export default {
  regions: [],
  projects: [],
  projectLoms: [],
  hyperionLoms: [],
  corporateLoms: [],
  hyperionEntities: [],
  compilations: [],
  yearlyFxRateTemplates: [],
  yearlyInflationRateTemplates: [],
  elementYearlyPriceTemplates: []
}
